import React from 'react';
import TimerDisplay from './TimerDisplay';


class CountTimer extends React.Component {
    constructor(){
        super();
        this.state = {
            sec:30,
            min:0
        }
    }

    componentDidMount(){
        this.count = setInterval(this._tick,1000);
    }

    componentWillUnmount(){
        clearInterval(this.count);
    }

    _resetTimer=()=>{
        this.setState({
            sec:30,
            min:0
        })
    }

    _tick=()=>{ 
    if(this.state.sec === 0 && this.state.min>0){
        this.setState(prevState => ({
        sec:prevState.sec+59,
        flag:true,
        min:prevState.min -1
        }));
      }
        
    else if(this.state.sec>0 && this.state.min>=0){
      this.setState(prevState => ({
        sec:prevState.sec - 1,
        flag:true,
        }));
    }
    else if(this.state.sec === 0 && this.state.min ===0){
    return;
    }
  
    }

    render(){
     const {sec,min} = this.state;  
     
        return (
            <TimerDisplay
                isLoading={this.props.isLoading}
                min={min}
                sec={sec}
                resetTimer={this._resetTimer}
                resendOtpNum={this.props.resendOtpNum} />
        );
        
    }
}

export default CountTimer;


// WEBPACK FOOTER //
// ./src/components/CountTimer.js